export default Object({
  // WEB_API_PATH: "/eAtalTunnelBooking/api/",
  // WEB_TOKEN_PATH: "/eAtalTunnelBooking/Token",
  // WEB_HUB_PATH: "/eAtalTunnelBooking/SignalR",  

  WEB_API_PATH: "/eAtalTunnelBooking/api/",
  WEB_TOKEN_PATH: "/eAtalTunnelBooking/Token",
  WEB_HUB_PATH: "/eAtalTunnelBooking/SignalR",

  // WEB_API_PATH: "/api/",
  // WEB_TOKEN_PATH: "/Token",
  // WEB_HUB_PATH: "/SignalR",
  LOG_Token: "bearer ".concat(window.sessionStorage.getItem("token")),
  AF_Token: window.sessionStorage.getItem("antiforgery_token")
});



// WEBPACK FOOTER //
// ./src/router/globalConfig.js